import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Calendar, CalendarDays, CalendarRange } from 'lucide-react';

const PERIODS = [
  { id: 'daily', path: '/timetracking/daily', icon: Calendar, labelKey: 'view_daily' },
  { id: 'weekly', path: '/timetracking/weekly', icon: CalendarDays, labelKey: 'view_weekly' },
  { id: 'monthly', path: '/timetracking/monthly', icon: CalendarRange, labelKey: 'view_monthly' },
];

const TimeTrackingPeriodToggle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const p = (key) => t(`modules.pointage.pages.timeTrackingPeriodToggle.${key}`);

  const active =
    PERIODS.find((period) => location.pathname.startsWith(period.path))?.id || 'daily';

  return (
    <div className="pointage-period-toggle bg-white/10 backdrop-blur-lg rounded-3xl p-2 border border-white/20 shadow-xl shadow-black/10">
      <div className="flex flex-wrap gap-1">
        {PERIODS.map((period) => {
          const Icon = period.icon;
          const isActive = active === period.id;
          return (
            <button
              key={period.id}
              type="button"
              onClick={() => navigate(period.path)}
              className={`pointage-period-btn flex-1 min-w-[100px] flex items-center justify-center gap-2 px-4 py-3 rounded-2xl font-semibold transition-all duration-300 ${
                isActive ? 'pointage-period-btn-active shadow-lg' : 'pointage-period-btn-inactive'
              }`}
            >
              <Icon className="h-5 w-5 shrink-0" />
              <span className="whitespace-nowrap">{p(period.labelKey)}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TimeTrackingPeriodToggle;
